import React from 'react';
import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import MietkautionsburgschaftJpg from './images/Mietkautionsburgschaft.png';
import MietkautionsburgschaftWebp from './images/Mietkautionsburgschaft.webp';
import MietkautionsburgschaftMobileJpg from './images/Mietkautionsburgschaft_mobile.jpg';
import MietkautionsburgschaftMobileWebp from './images/Mietkautionsburgschaft_mobile.webp';
import HowItWorksTab from './components/HowItWorksTab';
import { FAQList } from '../../../../common/display/faqTab/faqList/FAQList';
import CustomerService from './components/CustomerService';
import type { messages } from '../../../../../i18n/messages';
import OverviewTab from './components/OverviewTab';
import { useIntl } from '@/i18n';
import type { FormattedMessageDictionary } from '@/@types/FormattedMessageValue';

type FAQTabProps = {
  benefit: keyof (typeof messages)['de-DE']['benefits'];
  values?: FormattedMessageDictionary;
};

const FAQTab = ({ benefit, values }: FAQTabProps) => {
  return (
    <div>
      <FAQList benefit={benefit} values={values} />
      <CustomerService />
    </div>
  );
};

export const Mietkautionsburgschaft = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();

  return (
    <Modal
      title={t({ id: 'benefits.deposit.modal.headline', defaultMessage: 'Mietkautionsburgschaft' })}
      isVisible={isVisible}
      image={MietkautionsburgschaftJpg}
      imageWebp={MietkautionsburgschaftWebp}
      imageMobile={MietkautionsburgschaftMobileJpg}
      imageMobileWebp={MietkautionsburgschaftMobileWebp}
      imageUseFullWidth={true}
      imageAlt={t({
        id: 'benefits.deposit.modal.overview.image',
        defaultMessage: 'Woman using mortgage manager',
      })}
      tabsContent={[
        <OverviewTab key='benefits.deposit.modal.overview' />,
        <HowItWorksTab key='benefits.deposit.modal.howItWorks' />,
        <FAQTab key='benefits.deposit.modal.faq' benefit='deposit' />,
      ]}
      benefit={Benefit.DEPOSIT}
      onClose={onClose}
    />
  );
};
